import * as Sentry from "@sentry/nuxt"

const config = useRuntimeConfig();

Sentry.init({
  dsn: config.public.sentryDsn || undefined,

  // Setting this option to true will print useful information to the console while you're setting up Sentry.
  debug: false,
})
